import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import search from "../../assets/img/sreach---icon.svg"
import "../../assets/css/top-comm.css";
import profileimg from "../../assets/img/profile/profile-img.svg";
import { API } from "../../services/api";
import { getUserCommunities } from "../../services/apiPosts";
import { getUserCommunitySearch } from "../../services/apiOragnizations";

const TopCommunities = () => {
  const userData = JSON.parse(localStorage.getItem('userData'));
  const[mycommunities,setCommunities]=useState([]);
  const navigate = useNavigate();
  const[searchCommunities,setSearchCommunities]=useState([]);
  const [communityValue, setvalCommunity] = useState('');
  const [communitySearchSelected, setSearchCommunitySelected] = useState(false);
  const[searchCommunityId,setSearchCommunityId] = useState('');
  const searchkey='';
  useEffect(()=>{
    fetchCommunities(searchkey);
  },[])
   useEffect(()=>{
     if (communityValue !== '') {
      listSearchCommunities(communityValue)
    }
  },[communityValue])

   useEffect(() => {
        if(searchCommunityId){
            // List that community from the array of joined communities
          const filteredCommunities = mycommunities.filter(comm => comm.communityId._id === searchCommunityId);
           setCommunities(filteredCommunities);
         
        }
      
        }, [searchCommunityId])
 
  const fetchCommunities=async(searchkey)=>{
    let mycommunities = await getUserCommunities({"userid":userData._id,searchkey:searchkey})
    setCommunities(mycommunities.communities ||[]);
  }
  const listSearchCommunities=async(communityValue)=>{
      
        const communitieList = await(getUserCommunitySearch({userid:userData._id,searchkey:communityValue}));
        setSearchCommunities(communitieList.communities);
  }
  const ListOrganizations =async(communityId)=>{
    localStorage.setItem("FollowcommunityId", communityId);
    navigate('/top-organizations')
    
     
  }
 
  return (
    <div>
      <div class="container-fluid">
        <div class="row">
          <div className="hd-breadcums">
            <h3 className="main-heading">Communities</h3>
          </div>
        </div>
        <div class="">
          <div class="row">
           
            <div class="col-lg-4 my-2 ">
               <form className=" search-section  position-relative ">
              <div class="d-flex ">
                <div class=" search-box search-wrapper  d-flex align-items-center px-2 gap-2">
                  <span className="mobil-view-class border-end-0 ">
                    <img src={search} alt="search--Logo" className="search-logo-header mob-view-class pagess" />
                  </span>
                  <input type="text" name="communitySearch" class=" form-control border-start-0 search-inputs search-inside-color" placeholder="Search here"
                   id="exampleFormControlInput1"
                        value={communityValue}
                        onChange={(e) => {
                          e.preventDefault();
                          setvalCommunity(e.target.value);
                        
                          setSearchCommunitySelected(e.target.value !== ''); // Only show dropdown if there's text
                                      if (e.target.value === '') {
                                        setSearchCommunityId(''); // Clear search ID when input is cleared
                                        fetchCommunities(''); // Fetch all Communities
                                      }
                         
                        }}/>
                </div>
               
              </div>
              
                  {(searchCommunities.length > 0) && communitySearchSelected && (
                    <div className="col-lg-4 my-2 ">
                    <ul className="drop-div-join list-group mt-1 responsive-dropdown">
                      {searchCommunities.map((item, index) => (
                        <li key={index} className="list-group-item d-flex align-items-center">
                          <input
                            type="radio"
                            name="communityOption"
                            id={`option-${index}`}
                            value={item._id}
                            checked={communityValue === item.communityName}
                             onChange={(e) => {
                              e.preventDefault();
                              setvalCommunity(item.communityName);
                               setSearchCommunityId(item._id);
                              setSearchCommunitySelected(false);// Hide dropdown after selection
                              
                            }}
                            className="form-check-input me-2"
                          />
                          <label htmlFor={`option-${index}`} className="form-check-label w-100 mb-0">
                            {item.communityName}
                          </label>
                        </li>
                      ))}
                    </ul>
                    </div>
                  )}
                  </form>
            </div>

           
                 <div className="my-2">
              <div className="row ">
                 {
              mycommunities.map((community) => (
                <div className="col-lg-4 col-md-6 mb-2">
                  <button className="border-0 bg-transparent p-0 text-start w-100" onClick={() => ListOrganizations(community.communityId._id)}>
                    <div className="d-flex align-items-center custom-card">
                      <img src={community?.communityId?.profileImage?.url ? API.uploadFilePath + community?.communityId?.profileImage?.url : profileimg} alt="Avatar" className="top-community-img me-3" />
                      <div className="custom-card-text">
                        {community.communityId?.communityName}
                      </div>
                    </div>
                  </button>
                </div>
                 ))
            }
           
               
              </div>
            </div>

             

           
          </div>
        </div>
      </div>

    </div>

  );
};
export default TopCommunities;